module.exports = __webpack_public_path__ + "img/location.c9e5a14b.svg";